import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@commons';
import { GenericResponse } from '@interfaces';
import { Observable } from 'rxjs';
import { ImpersonalizeUser } from '../models/impersonalize-user.model';

@Injectable({
  providedIn: 'root'
})
export class ImpersonalizeUserService {

  constructor(private http: HttpClient, private config: ConfigService) { }

  public getUserImpersonalized(params: { MailUserToImpersonalize: string }): Observable<GenericResponse<ImpersonalizeUser>> {
    return this.http.get<GenericResponse<ImpersonalizeUser>>(
      this.config.getUrl('user.getUserImpersonalized'), { params }
    );
  }
}
